import React from "react";
//#region types
import { TitledContainerHeaderProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TitledContainerHeader: React.FC<TitledContainerHeaderProps> = (props) => {
  const { header, subHeader, stepCounterProps } = props;

  return (
    <Grid item container direction="column" className={cssExports.titledContainerHeader} gap={1}>
      {
        <Grid item container direction="row" columnGap={1} wrap="nowrap">
          {header ? (
            <Grid item xs className={cssExports.titledContainerTitle}>
              {header}
            </Grid>
          ) : (
            <></>
          )}
          {stepCounterProps ? (
            <Grid item className={cssExports.titledContainerStepCounter}>
              {stepCounterProps.currentStep} / {stepCounterProps.totalSteps}
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      }
      {subHeader ? (
        <Grid item container className={cssExports.titledContainerSubTitle}>
          {subHeader}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default TitledContainerHeader;
